import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CgPageLoader from 'modules/Common/layout/CgPageLoader';

// Most route chunks arrive well inside this window, and a preloaded one arrives
// almost at once. Showing nothing until then avoids a loader flash on every
// navigation.
const SHOW_AFTER_MS = 250;

/**
 * Suspense fallback for a lazy route.
 *
 * Plain "Loading" rather than CgPageLoader's rotating messages: those describe
 * computing costs and syncing suppliers, which is not what a code download is.
 *
 * Must stay in the entry graph (D4): it is what renders while chunks are failing.
 */
const RouteChunkFallback = () => {
  const { t } = useTranslation('common');
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), SHOW_AFTER_MS);
    return () => clearTimeout(timer);
  }, []);

  if (!visible) return null;
  return <CgPageLoader statusMessages={[t('loader.loading', 'Loading')]} />;
};

export default RouteChunkFallback;
